export const logos = [
  { id: 1, name: 'Accessories', image: 'Assets/Accessories.png' },
  { id: 2, name: 'Alohe', image: 'Assets/Alohe.png' },
  { id: 3, name: 'Devance', image: 'Assets/Devance.png' },
  { id: 4, name: 'Elola', image: 'Assets/Elola.png' },
  { id: 5, name: 'Hazelly', image: 'Assets/Hazelly.png' },
  { id: 6, name: 'Mango', image: 'Assets/Mango.png' },
  { id: 7, name: 'Marhessence', image: 'Assets/Marhessence.png' },
  { id: 8, name: 'Natural', image: 'Assets/Natural.png' },
  { id: 9, name: 'OVETAL', image: 'Assets/OVETAL.png' },
  { id: 10, name: 'SOARN', image: 'Assets/SOARN.png' },
]
